(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restock-collection-product-list"]) return;
  try {
    

   const quantityInputs = document.querySelectorAll('.quantity-input-field');
	
  
  const addToCartAll = document.getElementById('restock-add-to-cart-button');
  addToCartAll.addEventListener('click', event => {
      event.preventDefault()
      var items = [];
      var index = 0;

      quantityInputs.forEach(quantityInput => {
        const cleanQty = parseInt(quantityInput.value);
        const variantId = quantityInput.dataset.variant;

		if (cleanQty > 0 && variantId) {
          items[index] = {
            'quantity' : cleanQty,
            'id' :variantId
          };
          index++;
        }
        
     });

    let formData = {
      'items': items
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body:  JSON.stringify(formData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      window.location = window.location.origin + '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
    });
      
  });

  const quantityButtons = document.querySelectorAll('.quantity-input > button');
	quantityButtons.forEach(quantityButton => {
		quantityButton.addEventListener('click', event => {
			const { target } = event;
        	const quantityElement = target.parentElement;
            const quantityInput = quantityElement.querySelector('.quantity-input-field');
            const product = quantityInput.dataset.product;
            const qty = quantityInput.value;

            const unitPrice = document.getElementById("unit-" + product).dataset.price;

            var totalPrice = qty * unitPrice;

            if (totalPrice > 0) {
                totalPrice = totalPrice / 100;
            }

            const totalPriceElement = document.getElementById("total-" + product);
            totalPriceElement.dataset.totalprice = totalPrice;
            totalPriceElement.innerHTML = "$" + totalPrice.toFixed(2);

            calcuateTotal();
		});
	});

  function calcuateTotal() {
    const totalPrices = document.querySelectorAll('.item-calc-total');
    var restockTotal = 0;
    totalPrices.forEach(totalPrice => {
      if (totalPrice.dataset.totalprice) {
        restockTotal = restockTotal + parseFloat(totalPrice.dataset.totalprice);
      }
    });
    document.getElementById("restock-total-price").innerHTML = "$" + restockTotal.toFixed(2);

  }

  } catch(e) { console.error(e); }
})();
})();
